module.exports = __webpack_public_path__ + "static/media/SB4.656dd9dc.png";